// src/components/Contacts/EngagementDialog.js
import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField
} from '@mui/material';

const EngagementDialog = ({ open, onClose, contact, onSave }) => {
    const [status, setStatus] = useState('none');
    const [notes, setNotes] = useState('');

    useEffect(() => {
        if (contact) {
            setStatus(contact.engagement_status || 'none');
            setNotes(contact.engagement_notes || '');
        }
    }, [contact, open]);

    const handleSave = () => {
        onSave({
            engagement_status: status,
            engagement_notes: notes,
            last_engagement_date: new Date().toISOString()
        });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Update Engagement Status</DialogTitle>
            <DialogContent>
                <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel>Status</InputLabel>
                    <Select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        label="Status"
                    >
                        <MenuItem value="none">No Engagement</MenuItem>
                        <MenuItem value="engaged">In Discussion</MenuItem>
                        <MenuItem value="meeting_scheduled">Meeting Scheduled</MenuItem>
                        <MenuItem value="customer">Customer</MenuItem>
                        <MenuItem value="do_not_email">Do Not Email</MenuItem>
                    </Select>
                </FormControl>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    margin="normal"
                    label="Engagement Notes"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Add details about the engagement..."
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave} variant="contained">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EngagementDialog;